import React, { useContext, useState } from 'react';
import cn from "classnames";
import styles from "./common.module.scss"
import EnterCodeComponent from './components/EnterCodeComponent';
import NewPasswordComponent from './components/NewPasswordComponent';
import EnterEmailComponent from './components/EnterEmailComponent';
import FinishStepComponent from './components/FinishStepComponent';
import ArrowBackIcon from '../shared/icons/ArrowBackIcon';
import CheckCircleIcon from '../shared/icons/CheckCircleIcon';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import LanguageSelector from "../shared/LanguageSelector/LanguageSelector";

const ForgotPasswordPageNew = () => {
    const { t } = useTranslation(); // Initialize useTranslation
    const navigate = useNavigate();
    const [step, setStep] = useState(localStorage.getItem('step') ? Number(localStorage.getItem('step')) : 1);
    const [data, setData] = useState({})

    const stepDetails = [
        {
            title: t('restorePasswordPage.recoverPassword'),
            text: t('restorePasswordPage.enterEmail')
        },
        {
            title: t('restorePasswordPage.enterCode'),
            text: t('restorePasswordPage.codeSended', { email: data.userEmail })
        },
        {
            title: t('newPassword'),
            text: t('restorePasswordPage.resetPassword')
        },
        {
            title: t('restorePasswordPage.done'),
            text: t('restorePasswordPage.newPasswordSaved')
        }
    ];

    const renderContent = () => {
        switch (step) {
            case 1:
                return <EnterEmailComponent updateStep={(step) => setStep(step)} setData={(newData) => { setData({ ...data, ...newData }) }} data={data} />
            case 2:
                return <EnterCodeComponent updateStep={(step) => setStep(step)} setData={(newData) => { setData({ ...data, ...newData }) }} data={data} />
            case 3:
                return <NewPasswordComponent updateStep={(step) => setStep(step)} setData={(newData) => { setData({ ...data, ...newData }) }} data={data} />
            case 4:
                return <FinishStepComponent updateStep={(step) => setStep(step)} setData={(newData) => { setData({ ...data, ...newData }) }} data={data} />
        }
    }

    const previousStep = () => {
        setStep((prevStep) => Math.max(prevStep - 1, 1));
    };

    return (
        <div className={styles.containerReg}>
            <div className={cn(styles.containerReg_wallpaper, { [styles.wrapper_step_first]: step === 1 })}>
                <div className={styles.card}>

                    {/* Header */}
                    <div className={styles.card_topbar}>
                        <div className={styles.card_logo}>
                            <img src="/icons/ic_biny_dark.svg" alt="logo" />
                        </div>
                        <LanguageSelector />
                    </div>

                    {/* Main */}
                    <div className={styles.card_content}>
                        <div className={styles.card_head}>
                            {step == 4 ? (
                                <CheckCircleIcon />
                            ) : step === 1 ? (
                                <button className={styles.card_back} onClick={() => navigate('/login')}>
                                    <ArrowBackIcon />
                                </button>
                            ) : (
                                <button className={styles.card_back} onClick={previousStep} style={{ display: step == 1 ? "none" : "block" }}>
                                    <ArrowBackIcon />
                                </button>
                            )}
                            <div className={styles.card_title}>
                                <span>{stepDetails[step - 1].title}</span>
                            </div>
                            <div className={styles.card_head_text}>
                                <span>{stepDetails[step - 1].text}</span>
                            </div>
                        </div>

                        {renderContent()}

                    </div>
                </div>

                <div className={styles.right}>
                    <div className={styles.banner}>
                        <div className={styles.banner_dec}>
                            <div className={styles.banner_title}>{t('login.bannerTitle')}</div>
                            <div className={styles.banner_text}>{t('login.bannerText')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPasswordPageNew;
